:host {
  --card-max-width: 450px;
  --jump-card-ecommerce-showcase-max-width-horizontal: 100%;
  --jump-card-ecommerce-showcase-color: var(--neutral-grey-primary);
  --jump-card-ecommerce-showcase-background: transparent;
  --jump-card-ecommerce-showcase-border-color: var(--neutral-grey-background);
  --jump-card-ecommerce-showcase-padding: 0.5rem;
  --jump-card-ecommerce-showcase-out-of-stock-color: var(--status-danger-standard);
  --jump-card-ecommerce-showcase-available-color: var(--status-success-standard);
  --jump-card-ecommerce-showcase-discount-color: var(--status-danger-standard);
  --image-object-fit: cover;
  --jump-card-ecommerce-showcase-hide-discover-button-visibility: block;
  --jump-card-ecommerce-showcase-discount-badge-bg-color: var(--neutral-white);
  --jump-card-ecommerce-showcase-discount-badge-text-color: var(--primary-standard);
  --jump-card-ecommerce-showcase-discount-badge-padding: 4px 12px;
  --jump-card-ecommerce-showcase-discount-badge-border-radius: 50px;

  max-width: var(--card-max-width);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  font-family: var(--ff-primary, 'Arial'), sans-serif;
  line-height: var(--lh-400, 1.3);
  background-color: var(--jump-card-ecommerce-showcase-background);
  color: var(--jump-card-ecommerce-showcase-color);

  .DiscountBadge {
    position: absolute;
    bottom: 1rem;
    right: 0.2rem;
    z-index: 2;
    border: 2px solid var(--jump-card-ecommerce-showcase-discount-badge-text-color);
    color: var(--jump-card-ecommerce-showcase-discount-badge-text-color);
    background-color: var(--jump-card-ecommerce-showcase-discount-badge-bg-color);
    font-size: var(--fs-300);
    font-weight: var(--fw-900);
    padding: var(--jump-card-ecommerce-showcase-discount-badge-padding);
    border-radius: var(--jump-card-ecommerce-showcase-discount-badge-border-radius);
    line-height: 1.2;
  }

  .Footer,
  .Body {
    display: flex;
    width: 100%;
  }

  .Footer {
    container-type: inline-size;
    flex-direction: row;

    @container (max-width: 239px) {
      flex-direction: column;

            .OutOfStock {
        margin-bottom: 0.25rem;
      }

    }
  }

  jump-badge {
    position: absolute;
    top: 1rem;
    left: 1rem;
    z-index: 2;
  }

  .Media {
    container-type: inline-size;

    @container (max-width: 239px) {
      jump-badge {
        top: auto;
        bottom: 1rem;
        left: 0.2rem;
        right: auto;
      }
    }
  }


  .Media {
    // aspect-ratio: 3/4;
    overflow: hidden;
    position: relative;
    border-radius: 3px;
    aspect-ratio: 1/1;

    .Images {
      height: 100%;
      margin: 0;
      position: relative;

      img {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        object-fit: var(--image-object-fit, cover);
      }

      &__Front {
        z-index: 1;
        transition: opacity 0.5s linear;
        cursor: pointer;
      }

      
    }

    &.hasBackground {
      background-color: var(--neutral-white);

      &.iconOnly {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        padding: var(--jump-card-ecommerce-showcase-padding) var(--jump-card-ecommerce-showcase-padding) 0;

        img {
          border-radius: 6px;
        }
      }
    }

    &.iconOnly {
      border-bottom-right-radius: 0;
    }

    &.is-mini {
      max-width: 180px;
    }
  }

  .Content {
    container-type: inline-size;
    display: flex;
    flex-grow: 1;
    flex-direction: column;

     @container (max-width: 239px) {
       flex-direction: row;
     }

    &.hasBackground {
      background-color: var(--neutral-white);
      padding: calc(var(--jump-card-ecommerce-showcase-padding) * 2);
    }

    &.iconOnly {
      padding: calc(var(--jump-card-ecommerce-showcase-padding) * 2) var(--jump-card-ecommerce-showcase-padding);
    }

    &.is-mini {
      max-width: 180px;
    }
  }

  .Body {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: var(--jump-card-ecommerce-showcase-padding) 0;
    container-type: inline-size;

    & > * {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      & > * {
        flex: 0 1 auto;
      }
    }

    .Body__Top {
      display: flex;
      flex-direction: row;
    }

    .Body__Bottom {
      display: flex;
      flex-direction: row;
    }
    
    &.is-vertical {
      .Body__Top {
        flex-direction: column;
        align-items: flex-start;
       
        .Subtitle {
           min-height: 3.5rem;
        }

        @container (max-width: 239px) {
          .Subtitle {
            min-height: 3.2rem;
          }
        }
      }

      .Price {
        justify-items: start;
        margin-top: 0.5rem;
        column-gap: 0;
        display: flex;
        flex-direction: column-reverse;
        align-items: flex-start;
      }

    }

    @container (max-width: 239px) {
      .Body__Top {
        flex-direction: column;
      }

      .Body__Bottom {
        flex-direction: column;
      }

      .SelectVariations {
        max-width: 100%;
        margin-bottom: 0.5rem;

        select {
          width: 100%;
        }
      }

      .Price {
        display: flex;
        flex-direction: column-reverse;
        margin-top: 0.5rem;
        align-items: start;
      }
    }

    &.hasBackground {
      padding: 0 0 var(--jump-card-padding);
    }

    &.iconOnly {
      padding: 0;
    }

    &.is-mini {
      & > * {
        flex-direction: column;
      }

      padding: calc(var(--jump-card-padding) / 2) 0;
    }
  }

  .Product {
    font-size: var(--fs-400);
    color: var(--neutral-grey-primary);
    text-decoration: none;
  }

  .Subtitle {
    font-size: var(--fs-300);
    color: var(--neutral-grey-secondary);
    line-height: 1.2;
  }

  .Subtitle:hover {
    cursor: pointer;
  }

  .OutOfStock, .AvailableStock {
    justify-items: start;
    font-size: var(--fs-300);
    font-weight: var(--fw-900);
    margin-top: 0.5rem;
  }

  .OutOfStock {
    color: var(--jump-card-ecommerce-showcase-out-of-stock-color);
  }

  .AvailableStock {
    color: var(--jump-card-ecommerce-showcase-available-color);
  }

  .Price {
    position: relative;
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: 1.5rem 1.5rem auto;
    justify-items: end;
    align-items: end;
    column-gap: 0.5rem;
    margin-top: 0;
    

    font-size: var(--fs-500);
    font-weight: var(--fw-900);
    line-height: var(--lh-400);

    & > * {
      display: inline-flex;
    }

    &__Regular {
      text-align: right;

      &.sale {
        text-decoration: line-through;
        color: var(--neutral-grey-secondary);
        font-weight: var(--fw-400);
        font-size: var(--fs-400);
        grid-column: 2;
        grid-row: 1;
      }
    }

    &__Sale {
      grid-column: 2;
      grid-row: 2;
    }

    &__Discount {
      color: var(--jump-card-ecommerce-showcase-discount-color);
      font-weight: var(--fw-400);
      font-size: var(--fs-300);
      grid-column: 1;
      grid-row: 1;
    }

    &.is-mini {
      display: flex;
      font-size: var(--fs-400);
    }
  }
}